var LanguageCodeFactory = function ($resource, $window) {

    var retrieveLanguageCodeApi = "/participant-web-services/rest/partialauth/profile/retrieveLanguageCode";
    var retrieveWebLanguageCodeApi = "/participant-web-services/rest/partialauth/profile/retrieveWebLanguageCode";
    var updateLanguageCodeApi = "/participant-web-services/rest/partialauth/profile/updateLanguageCode";
    var setLanguageCookiesApi = "/participant-web-services/rest/partialauth/profile/setSpnLangCookies";

    return {
        retrieveLanguageCode: $resource(__baseApiUrl__ + retrieveLanguageCodeApi, {}, {
            query: {
                method: 'GET',
                isArray: false,
            }
        }),

        retrieveWebLanguageCode: $resource(__baseApiUrl__ + retrieveWebLanguageCodeApi, {}, {
            query: {
                method: 'GET',
                isArray: false,
            }
        }),

        updateLanguageCode: $resource(__baseApiUrl__ + updateLanguageCodeApi, {}, {
            query: {
                method: 'POST',
                isArray: false,
                headers: { 'Content-Type': 'application/json' }
            }
        }),

        setLanguageCookies: $resource(__baseApiUrl__ + setLanguageCookiesApi, {}, {
            query: {
                method: 'POST',
                isArray: false,
                headers: { 'Content-Type': 'application/json' }
            }
        }),
    };
};

LanguageCodeFactory.$inject = ['$resource', '$window'];
export default LanguageCodeFactory;
